import { color, media, radius, spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div``

export const BleedContent = styled.div`
  background: ${color('gray.06')};
  margin: ${spacing(0, -4)};
  padding: ${spacing(0, 0, 10)};

  ${media.tablet} {
    margin: ${spacing(0, -4)};
    padding: ${spacing(0, 4, 10)};
  }

  ${media.pc} {
    margin: ${spacing(0, -10)};
    padding: ${spacing(0, 10, 10)};
  }
`

export const TopContent = styled.div`
  padding: ${spacing(2, 4)};
`

export const BulletedList = styled.ul`
  margin-top: ${spacing(6)};
`

export const BulletedListItem = styled.li`
  color: ${color('gray.04')};
  display: flex;
  align-items: flex-start;
  margin-top: ${spacing(2)};
  word-break: break-word;

  &::before {
    content: '';
    display: block;
    min-height: 6px;
    min-width: 6px;
    width: 6px;
    height: 6px;
    margin-top: 0.7em;
    margin-right: 6px;
    background: ${color('gray.04')};
    border-radius: ${radius('full')};
  }

  &:first-child {
    margin-top: 0;
  }
`

export const BorderTopFlex = styled.div`
  display: flex;
  border-top: 1px solid ${color('gray.04')};
`
